import DashboardMgmtReducer, { actions } from "./reducer";
import * as thunkActions from "./actions";
export const dashboardMgmtActions = { ...actions, ...thunkActions };
export * as DashboardMgmtTypes from './types';
export default DashboardMgmtReducer;
